import React from 'react';
import PlaceholderPage from './PlaceholderPage';
import { CreditCard } from 'lucide-react';

export default function BusinessCardsPage() {
  return (
    <PlaceholderPage
      title="Business Cards"
      description="Manage digital business cards inventory and designs."
      icon={CreditCard}
    />
  );
}
